export const REQUEST_SET_DOCUMENT_CONTENT = 'REQUEST_SET_DOCUMENT_CONTENT';
export const RESET_STORE_DOCUMENT = 'RESET_STORE_DOCUMENT';
export const REQUEST_GET_DOC_BY_DOCUMENTUM_ID =
  'REQUEST_GET_DOC_BY_DOCUMENTUM_ID';
